<template>
  <div>
    <!--前台QA配置  -->
    <baseBreadcrumb :page="$t('message.qaManage')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="search">
        <div class="btn">
          <!-- 添加一类类目 -->
          <el-button type="success" @click="addACategory">
            {{ $t('message.addACategory') }}
          </el-button>
          <!-- 添加题目 -->
          <el-button type="success" @click="articleAdd">
            {{ $t('message.addQuestion') }}
          </el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <div class="item" v-for="(item, index) in tableData" :key="index">
          <div class="head">
            <!-- 排序 -->
            <div class="sort items">
              {{ $t('message.sort') }}
            </div>
            <!-- 类目名 -->
            <div class="categoryName  items">
              {{ $t('message.categoryName') }}
            </div>
            <!-- 操作 -->
            <div class="operation items">
              {{ $t('message.operation') }}
            </div>
          </div>
          <div class="content">
            <!-- 排序 -->
            <div class="sort items">
              {{ item.sort }}
            </div>
            <!-- 类目名 -->
            <div class="categoryName  items">
              {{ item.name }}
            </div>
            <!-- 操作 -->
            <div class="operation items">
              <i class="el-icon-edit-outline" @click="categoryEdit(item)"></i>
              <i class="el-icon-delete" @click="categoryDelete(item.id)"></i>
            </div>
          </div>
          <ol v-if="item.qa_article != false">
            <!-- 题目 -->
            <li class="flex3"> {{ $t('message.subject') }}</li>
            <!-- 答案 -->
            <li class="flex5"> {{ $t('message.answer') }}</li>
            <!-- 排序 -->
            <li> {{ $t('message.sort') }}</li>
            <!-- 操作 -->
            <li class="flex15"> {{ $t('message.operation') }}</li>
          </ol>
          <ul v-for="(items, indexs) in item.qa_article" :key="indexs">
            <!-- 题目 -->
            <li class="flex3"> {{ items.title }}</li>
            <!-- 答案 -->
            <li class="flex5"> <el-button type="primary" @click="preview(items)">预览</el-button></li>
            <!-- 排序 -->
            <li class="flex"> {{ items.sort }}</li>
            <!-- 操作 -->
            <li class="flex15 flex">
              <i class="el-icon-edit-outline" @click="articleEdit(items)"></i>
              <i class="el-icon-delete" @click="articleDelete(items.id)"></i>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 添加编辑类目 -->
    <categor :isAdd="isAdd" ref="categor" />
    <!-- 添加编辑题目 -->
    <Article :isAdd="isAdd" ref="Article" :tableData="tableData" />
    <!-- 预览 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="1200px" center title="预览">
      <div v-html="content" class="preview ql-editor"></div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
import categor from './components/categor'
import Article from './components/article'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
export default {
  components: {
    categor,
    Article
  },
  data() {
    return {
      tableData: [],
      isAdd: true,
      dialogVisible: false,
      content: '',
    };
  },
  created() {
    this.articleList()
  },
  methods: {
    articleList() {
      this.$api.siteConfiguration.articleList({ keyword: '' }).then(res => {
        this.tableData = res.data
      })
    },
    // 新增类目
    addACategory() {
      this.isAdd = true
      this.$refs.categor.acceptData({
        name: '',
        sort: 0
      })
    },
    // 新增类目
    addACategory() {
      this.isAdd = true
      this.$refs.categor.acceptData({
        name: '',
        sort: 0
      })
    },
    //修改类目
    categoryEdit(item) {
      this.isAdd = false
      let itemData = JSON.parse(JSON.stringify(item))
      this.$refs.categor.acceptData(itemData)
    },
    //删除类目
    categoryDelete(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.siteConfiguration.categoryDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.articleList()

          })
        })
        .catch(() => { });

    },
    //新增问题
    articleAdd() {
      this.isAdd = true
      this.$refs.Article.acceptData({
        category_id: '',
        title: '',
        sort: 0,
        content: '',
      })
    },
    // 文章-修改
    articleEdit(item) {
      this.isAdd = false
      let itemData = JSON.parse(JSON.stringify(item))
      this.$refs.Article.acceptData(itemData)
    },
    //删除问题
    articleDelete(id) {
      this.$confirm(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true
        }
      )
        .then(() => {
          this.$api.siteConfiguration.articleDelete({ id }).then(res => {
            this.$message.success(res.msg)
            this.articleList()

          })
        })
        .catch(() => { });

    },
    //预览
    preview(item) {
      this.content = item.content
      this.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
.search {
  margin: 0 0 20px 0;
  height: 40px;
  text-align: right;
}

.table {
  .item {
    &:nth-child(1) {
      border-top: 1px solid #ccc;
    }

    i {
      margin-left: 20px;
      font-size: 25px;
      cursor: pointer;

      &:hover {
        color: #b4272d;
      }

    }

    .head,
    .content {
      display: flex;
      background-color: #EDEFF4;
      border: 1px solid #ccc;
      border-top: 0;



      .items {
        text-align: center;
        padding: 10px 0;
        border-right: 1px solid #ccc;

        &:nth-last-child(1) {
          border: 0;
        }
      }

      .sort {
        flex: 1;
      }

      .categoryName {
        flex: 8;
      }

      .operation {
        flex: 1.5;
      }
    }

    .content {
      background-color: #fff;
      border-top: 0 !important;
    }

    ol {
      border: 1px solid #ccc;
      border-top: 0;
      text-align: center;
    }

    ul {
      border: 1px solid #ccc;
      border-top: 0;
      padding: 0;
    }

    li {
      border-right: 1px solid #ccc;
      padding: 10px 0;
      display: block;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex3 {
      flex: 3;
    }

    .flex5 {
      flex: 5;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

}

/deep/.preview {
  h1 {
    font-size: 32px;
    font-weight: bold;
  }

  h2 {
    font-size: 24px;
    font-weight: bold;
  }

  h3 {
    font-size: 18.72px;
    font-weight: bold;
  }

  h4 {
    font-size: 16px;
    font-weight: bold;
  }

  h5 {
    font-size: 13.28px;
    font-weight: bold;
  }

  h6 {
    font-size: 12px;
    font-weight: bold;
  }

  img {
    max-width: 100% !important;
  }

  p {
    font-size: 16px;
    color: #000
  }


}
</style>